import { NgModule } from '@angular/core';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';

import { oase_config } from '../../environments/environment';
import { APIConfigService } from '../api.config.service';
import { RedirectComponent } from './redirect.component';

const PATH_FILE = 'app/shared/auth.module.ts';

export function jwtOptionsFactory(apiConfigService: APIConfigService) {
	return {
		tokenGetter: () => {
			let token = localStorage.getItem(oase_config.auth_token.name);
			return token },
			whitelistedDomains: ['localhost', 'localhost:4200','localhost:8080','liswebtest.kaerntnermilch.at']

	};
}

export function tokenGetter() {
	return localStorage.getItem('authtoken');
}

@NgModule({
    imports: [
        // HttpClientModule,
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                useFactory: jwtOptionsFactory,
                deps: [APIConfigService]
            }
        }),
        RedirectComponent
    ]
})
export class AuthModule {}